import { memo } from "react";

/**
 * Crealo logo icon only (without text)
 * Size matches the icon part in the full logo: (150/762) * 110 ≈ 21.65px
 */
const LogoIcon = () => (
    <svg width="22" height="22" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M75.007 24.9762C65.1473 34.8344 53.1595 37.8475 40.6147 34.3917L34.3685 40.6369C37.8249 53.1797 34.8303 65.1466 24.9706 75.0048L0 50.0286C9.85969 40.1704 12.8495 28.2035 9.39789 15.6607L15.6441 9.41546C28.1889 12.8713 40.1767 9.85815 50.0364 0L75.0118 24.9714L75.007 24.9762Z"
            fill="#2D2D2D"
        />
        <path
            d="M24.9754 75C34.835 84.8582 37.8487 96.8441 34.3923 109.387L40.6385 115.632C53.1833 112.176 65.1521 115.17 75.0118 125.029L50.0364 150C40.1767 140.142 28.208 137.153 15.6632 140.604L9.41694 134.358C12.8733 121.816 9.85969 109.83 0 99.9714L24.9754 75Z"
            fill="#2D2D2D"
        />
        <path
            d="M75.007 125.024C84.8667 115.166 96.8545 112.153 109.399 115.608L115.646 109.363C112.189 96.8203 115.184 84.8534 125.043 74.9952L150.019 99.9667C140.159 109.825 137.169 121.792 140.621 134.335L134.375 140.58C121.83 137.124 109.842 140.137 99.9824 149.995L75.007 125.024Z"
            fill="#2D2D2D"
        />
        <path
            d="M125.039 75C115.179 65.1419 112.165 53.1559 115.622 40.6131L109.375 34.3679C96.8307 37.8237 84.8619 34.8296 75.0022 24.9714L99.9824 0.00476009C109.842 9.86291 121.811 12.8522 134.356 9.40118L140.602 15.6464C137.145 28.1893 140.159 40.1752 150.019 50.0333L125.043 75.0048L125.039 75Z"
            fill="#2D2D2D"
        />
    </svg>
);

export default memo(LogoIcon);
